import { Subscription } from 'rxjs';
import { SaveChangesComponent } from './../core-content-manager/modals/save-changes/save-changes.component';
import { ErrorsComponent } from './../core-content-manager/modals/errors/errors.component';
import { SuccessComponent } from './../core-content-manager/modals/success/success.component';
import { MatDialog } from '@angular/material/dialog';
import {
  // NgxSpinnerModule,
   NgxSpinnerService } from 'ngx-spinner';
import { GetService } from 'src/app/Services/get.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { contentLists } from '../core-content-manager/contentForms';
import {
  FormBuilder,
  // FormControl,
  FormGroup,
  // Validators,
} from '@angular/forms';
import { PostService } from '../Services/post.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss'],
})
export class SettingComponent implements OnInit, OnDestroy {
  mainForm: FormGroup;
  sections = null;
  fieldsCtrls = {};
  formData = new FormData();
  settingData;
  imageUrl=environment.imgUrl;
  recordData: any;
  imageSrc = new Map();
  // fileType = new Map();
  imageSizeError = new Map();
  settingsSubscription = new Subscription();
  settingPostSubscription = new Subscription();
  constructor(
    private service: GetService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private post: PostService,
    private dialog: MatDialog,
    public _domSanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.spinner.show();

   this.settingsSubscription = this.service.get(contentLists.setting.link_group).subscribe((res) => {
      this.sections = contentLists.setting.sections;





      this.settingData = res.response.data;
      
      for (let section of this.sections) {
        let sectionData = this.settingData[section.key];

        for (let element of sectionData) {
          if(element.value=='null' ||element.value==null ){
            element.value='';


          }
          this.fieldsCtrls[element.key] = [element.value ];
           if (element.image_dimensions != null) {
            this.imageSrc[element.key] =  this.imageUrl +element.value;
          //   this.imageSizeError[f.name] = false;

            }
        }
      }

      this.mainForm = this.fb.group(this.fieldsCtrls);

      setTimeout(() => {
        this.spinner.hide();
      }, 1000);
    });
  }
  openDialog() {
    this.mainForm.markAllAsTouched();
    if (this.mainForm.valid) {
      const dialogref = this.dialog.open(SaveChangesComponent, {
        data: 'Are You sure you want to save edits?',
      });
      dialogref.afterClosed().subscribe((reply) => {
         if (reply) {
          this.submit();
        }
      });
    }
  }

  submit() {

    // this.submitted = true;
    for (let key in this.fieldsCtrls) {
      this.formData.append(key, this.mainForm.get(key).value);
    }
     if (this.mainForm.valid) {
      this.settingPostSubscription = this.post.submit('dashboard/setting', this.formData).subscribe(
        (data) => {
          this.spinner.show();
          setTimeout(() => {
            this.spinner.hide();
            this.dialog.open(SuccessComponent);
          }, 1000);
        },
        (err) => {
          this.spinner.show();
          setTimeout(() => {
            this.spinner.hide();
            this.dialog.open(ErrorsComponent);
          }, 1000);
        }
      );
    }
  }


  renderingFormImages() {
    for (let fieldName in this.imageSrc) {
      this.imageSrc[fieldName] = this.imageUrl + this.recordData[fieldName];

     }
  }

  triggerClick(fieldID) {
    document.getElementById(fieldID).click();
  }

  upload(event, fieldName) {
    // this.progress = 1;
    let file;
    let fileSize;
    const files: File = event.target.files;
    file = files[0];

    fileSize = Math.round(file.size / 1024);
     // let   limited_size= this.getFileType(file.type)=='image'?3072:5120;
    let vaildSize = fileSize <= 5120;

    const reader = new FileReader();

    if (event.target.files.length && vaildSize) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.imageSizeError[fieldName] = false;
        this.imageSrc[fieldName] = reader.result as string;


        this.formData.append(fieldName, event.target.files[0]);
      };
    } else {
      this.imageSizeError[fieldName] = true;
    }
  }
  ngOnDestroy(): void {
    this.settingsSubscription.unsubscribe();
    this.settingPostSubscription.unsubscribe();
  }
}
